import * as React from 'react';
import { FormInputsLayout } from '../FormInputsLayout';
import { InlineText1 } from '@cian/ui-kit';

export interface IRangeQuestionProps {
  unit?: React.ReactNode | null;
  gteValue: string | number;
  gteError?: string;
  gtePlaceholder: string;
  lteValue: string | number;
  ltePlaceholder: string;
  lteError?: string;

  handleChange(e: React.ChangeEvent<HTMLInputElement>): void;
}

export const RangeQuestion: React.FC<IRangeQuestionProps> = props => {
  const { unit, gteValue, lteValue, gteError, lteError, handleChange, gtePlaceholder, ltePlaceholder } = props;
  const gteRef = React.useRef<HTMLInputElement>(null);
  const lteRef = React.useRef<HTMLInputElement>(null);

  const handleGteEnhancerClick = React.useCallback(() => {
    /* istanbul ignore else */
    if (gteRef.current) {
      gteRef.current.focus();
    }
  }, [gteRef]);
  const handleLteEnhancerClick = React.useCallback(() => {
    /* istanbul ignore else */
    if (lteRef.current) {
      lteRef.current.focus();
    }
  }, [lteRef]);

  return (
    <FormInputsLayout
      InputProps={{
        errorMessage: gteError,
        invalid: !!gteError,
        name: 'gte',
        type: 'text',
        inputRef: gteRef,
        onChange: handleChange,
        rightEnhancer: unit,
        leftEnhancer: (
          <InlineText1 onClick={handleGteEnhancerClick} color="gray40_100" userSelect="none">
            {gtePlaceholder}
          </InlineText1>
        ),
        value: gteValue,
        'data-testid': 'gte',
      }}
      secondInputProps={{
        errorMessage: lteError,
        invalid: !!lteError,
        name: 'lte',
        type: 'text',
        inputRef: lteRef,
        onChange: handleChange,
        rightEnhancer: unit,
        leftEnhancer: (
          <InlineText1 onClick={handleLteEnhancerClick} color="gray40_100" userSelect="none">
            {ltePlaceholder}
          </InlineText1>
        ),
        value: lteValue,
        'data-testid': 'lte',
      }}
    />
  );
};

RangeQuestion.displayName = 'RangeQuestion';
